import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { MODAL_TRYIT } from '@/components/organisms/Modals/ModalConductor';
import {
  PopoverCombobox,
  type PopoverComboboxOption,
} from '@/components/ui/custom/PopoverCombobox';
import useBrains from '@/hooks/useBrains';
import { pushModal } from '@/redux/modals/actions';
import { setBrainId } from '@/redux/session/actions';
import { selectBrainId } from '@/redux/session/selectors';

export const AIAgentsSelect = ({ handleReset, handleCloseModal, collectionLanguage }) => {
  const { t } = useTranslation();
  const reduxBrainId = useSelector(selectBrainId);
  const { brains, brainsByLanguage } = useBrains();
  const dispatch = useDispatch();

  const options: PopoverComboboxOption[] = useMemo(() => {
    const filtered = collectionLanguage ? brainsByLanguage(collectionLanguage) : (brains ?? []);
    return filtered.map((brain) => ({ value: brain.brain_id, label: brain.name }));
  }, [brains, collectionLanguage, brainsByLanguage]);

  const handleChange = (brainId: string) => {
    dispatch(setBrainId({ brainId }));

    handleReset();
    handleCloseModal();

    dispatch(pushModal(MODAL_TRYIT, { brainId, collectionLanguage }));
  };

  return (
    <PopoverCombobox
      options={options}
      value={reduxBrainId ?? ''}
      onChange={handleChange}
      triggerPlaceholder={t('common.select')}
      maxWidth="max-w-44"
      contentClassName="z-1400"
    />
  );
};
